import { render, staticRenderFns } from "./Claps.vue?vue&type=template&id=1399d69c&scoped=true"
import script from "./Claps.vue?vue&type=script&lang=js"
export * from "./Claps.vue?vue&type=script&lang=js"
import style0 from "./Claps.vue?vue&type=style&index=0&id=1399d69c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1399d69c",
  null
  
)

export default component.exports